import { RouteRecordRaw } from 'vue-router';

const TENANT_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'TenantsOverview',
      component: () => import('@/modules/tenants/pages/TenantsOverview.vue'),
   },
   {
      path: ':id',
      name: 'TenantDetail',
      component: () => import('@/modules/tenants/pages/TenantDetail.vue'),
      children: [
         {
            path: 'general',
            alias: '',
            name: 'TenantGeneral',
            component: () => import('@/modules/tenants/components/tenant-detail/TenantGeneral.vue'),
         },
         {
            path: 'users',
            name: 'TenantUsers',
            component: () => import('@/modules/tenants/components/tenant-detail/TenantUsers.vue'),
         },
         {
            path: 'teams',
            name: 'TenantTeams',
            component: () => import('@/modules/tenants/components/tenant-detail/TenantTeams.vue'),
         },
         {
            path: 'employers',
            name: 'TenantEmployers',
            component: () => import('@/modules/tenants/components/tenant-detail/TenantEmployers.vue'),
         },
         {
            path: 'clusters',
            name: 'TenantClusters',
            component: () => import('@/modules/tenants/components/tenant-detail/TenantClusters.vue'),
         },
         {
            path: 'internal-job-functions',
            name: 'TenantInternalJobFunctions',
            component: () => import('@/modules/tenants/components/tenant-detail/TenantInternalJobFunctions.vue'),
         },
         {
            path: 'permissions',
            name: 'TenantPermissions',
            component: () => import('@/modules/tenants/components/tenant-detail/TenantPermissions.vue'),
         },
      ],
   },
];

export default TENANT_ROUTES;
